import React, { useState, forwardRef } from "react";
import styled from "styled-components";
import { Input } from "./index-styled";
import EyeIconClosed from "_c/icon/EyeClosed";
import EyeIconOpen from "_c/icon/EyeOpen";

const StyledInput = styled(Input)`
  padding-right: 40px;
`;
const Wrap = styled.div`
  position: relative;
`;

const Btn = styled.button`
  box-shadow: none;
  border: none;
  background: transparent;
  border-radius: 0;
  position: absolute;
  right: 18px;
  top: 11px;
`;
const PassInput = forwardRef(({ ...props }, ref) => {
  const [show, setShow] = useState(false);
  return (
    <Wrap>
      <StyledInput {...props} ref={ref} type={show ? "text" : "password"} />
      <Btn onClick={() => setShow(!show)} type="button">
        {show ? (
          <EyeIconOpen color="var(--font-color-emp)" width="16" />
        ) : (
          <EyeIconClosed color="var(--font-color-emp)" width="16" />
        )}
      </Btn>
    </Wrap>
  );
});
PassInput.displayName = "PassInput";
export default PassInput;
